
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workerscompensationrates/contact-us",
      function () {
        return require("private-next-pages/workerscompensationrates/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workerscompensationrates/contact-us"])
      });
    }
  